import css from './Header.module.css';

function Header({ userEmail, onLogout }) {
    return (
        <div className={css.header}>
            <div className={css.logo}>
                <img src="logo-white.png" alt="logo" />
            </div>
            <div className={css.title}>
                <span>Plane Care Academy</span>
            </div>
            <div className={css.info}>
                <span className={css.email}>{userEmail}</span>
                {onLogout && (
                    <button
                        type="button"
                        className={css.logoutBtn}
                        onClick={onLogout}
                        aria-label="Logout"
                        title="Logout"
                    >
                        <i className="fa-solid fa-right-from-bracket" />
                    </button>
                )}
            </div>
        </div>
    );
}

export default Header;
